import Modal, { DEFAULT_OPTIONS } from 'CoreComponents/modal';
import IntlTelInput from 'intl-tel-input';

document.querySelectorAll(`.${DEFAULT_OPTIONS['className']['MODAL']}`).forEach(modal => {
  if (!modal.classList.contains('modal-video')) {
    new Modal(modal);
  }
});

class CustomerDetail {
  constructor() {
    this._setup();
  }

  _setup() {
    const telInput = document.querySelector('#user_phone_number');
    const iti = IntlTelInput(telInput, {
      initialCountry: 'th'
    });

    const numberType = iti.selectedCountryData.dialCode;
    telInput.value = telInput.value.replace(`+${numberType}`, '');

    const submit = document.querySelector('.form-user-profile button[type="submit"]');
    submit.addEventListener('click', this.clickHandler);
  }

  clickHandler(event) {
    const telInput = document.querySelector('#user_phone_number');
    const iti = window.intlTelInputGlobals.getInstance(telInput);

    const numberType = iti.selectedCountryData.dialCode;
    const phoneNumber = telInput.value;

    telInput.value = `+${numberType}${phoneNumber}`;
  }
}

if (document.querySelector('#user_phone_number')) {
  new CustomerDetail();
}



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/modal.js